import { NavLink } from 'react-router-dom';
import ReceiveSvg from '../../images/icons/receive.svg?react';
import { useTranslation } from 'react-i18next';

type Props = {
  forDropdown?: boolean;
  forNavPill?: 'left' | 'right';
  clickHandler?: () => void;
};

export const ReceiveACartBlock = ({ forDropdown, forNavPill, clickHandler }: Props) => {
  const { t } = useTranslation();

  const className = forNavPill
    ? 'group inline-flex items-center gap-2 whitespace-nowrap bg-primary-off px-5 py-2 font-secondary font-bold text-sm md:text-base text-offWhite hover:bg-primary-offHover transition-all active:scale-[97%]'
    : forDropdown
    ? 'group inline-flex flex-row flex-nowrap items-center justify-start gap-2 whitespace-nowrap transition-all active:scale-[97%] h-7 w-full rounded-md px-1 py-0.5 text-primary hover:bg-gray-300/60'
    : 'group inline-flex flex-row flex-nowrap items-center justify-start gap-2 whitespace-nowrap transition-all active:scale-[97%] w-fit px-1 py-1 text-skyBlue hover:text-white';

  return (
    <NavLink to='/get' onClick={clickHandler} className={className}>
      <ReceiveSvg
        width={forDropdown ? 18 : 20}
        title='Receive Cart Icon'
        style={forNavPill ? { fill: '#26CA99' } : undefined}
        className={`${
          forDropdown ? 'fill-primary pt-0.5' : forNavPill ? '' : 'fill-skyBlue group-hover:fill-white'
        } transition-all`}
      />
      {forNavPill ? t('common.receive') : t('common.receive_a_cart')}
    </NavLink>
  );
};
